module.exports = __webpack_public_path__ + "img/footer-img-1.32a017a8.png";